const styles = (theme) => ({
  header: ({ bottomBorder = true, fullPage }) => ({
    display: 'inherit',
    borderBottom: bottomBorder
      ? `1px solid ${theme.palette.primary.whiteDark}`
      : undefined,

    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(fullPage ? 4 : 1),
      paddingBottom: theme.spacing(fullPage ? 4 : 1),

      '@supports (padding-top: env(safe-area-inset-top))': {
        paddingTop: `calc(env(safe-area-inset-top) + ${theme.spacing(
          fullPage ? 4 : 1
        )}px)`,
      },
    },
  }),
  hidden: {
    display: 'none !important',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    justifyContent: 'space-between',
    height: '100%',
  },
  children: {
    flexGrow: 1,
  },
  isDesktop: ({ fullPage }) => ({
    boxShadow: fullPage ? undefined : 'none',
  }),
  marginLeftZero: {
    marginLeft: 0,
  },
});

export default styles;
